import React from "react";
import "./intro.css";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import avatar from './fox.jpg';
function intro() {
  return (
    <div className="intro__container">
    <img src = {avatar}/>
      <Link to="/visualizer">
        <button>Enter Algorithm Visualizer</button>
      </Link>
    </div>
  );
}

export default intro;
